"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeAuthenticationEvent = exports.publishAuthenticationEvent = void 0;
const events_1 = require("../../features/events");
const factory_1 = require("./factory");
const CHANNEL_KEY = 'reauthenticationEvent';
exports.publishAuthenticationEvent = (0, factory_1.createPublishFunction)(CHANNEL_KEY, events_1.ReauthenticationEvent);
exports.subscribeAuthenticationEvent = (0, factory_1.createSubscribeFunction)(CHANNEL_KEY);
//# sourceMappingURL=reauthentication.js.map